<template>
  <div class="d-flex pt-4 pb-3 ml-3">
    <div class="mr-4">
      <b-form-checkbox v-model="caixaStatus"
                       name="check-button"
                       switch
                       @change="handlerFrenteCaixa">
        Frente de Caixa
      </b-form-checkbox>
    </div>
    <div>
      <b-form-checkbox v-model="mensalistaStatus"
                       name="check-button"
                       switch
                       @change="handlerMensalista">
        Mensalista
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
  import CartorioService from '../../../services/CartorioService'

  export default {
    name: 'ModulosServentia',
    data () {
      return {
        cartorioObj: null,
        caixaStatus: true,
        mensalistaStatus: false,
      }
    },
    created () {
      this.cartorioObj = this.$store.state.auth.cartorioObj
      this.caixaStatus = !!this.cartorioObj.frente_caixa
      this.mensalistaStatus = !!this.cartorioObj.mensalista
    },
    methods: {
      async handlerFrenteCaixa () {
        await CartorioService.moduloCaixaStatus(this.cartorioObj.cartorio_id)
        this.updateCartorioStore()
      },
      async handlerMensalista () {
        await CartorioService.moduloMensalistaStatus(this.cartorioObj.cartorio_id)
        this.updateCartorioStore()
      },
      async updateCartorioStore () {
        const { data } = await CartorioService.getCartorioRei(this.cartorioObj.cartorio_id)
        this.$store.dispatch('auth/setCartorioObj', data)
      }
    }
  }
</script>

<style lang="scss">

</style>
